import React, { useState, useEffect } from 'react';
import styles from './Header.module.css';
import { FaBars, FaTimes } from 'react-icons/fa';
import translation from '../../../helpers/translation/index';
import { NavLink, useParams } from 'react-router-dom';
import { Dropdown, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { lang } = useParams();

  const activeTranslate = translation[lang || 'en'];

  // Блокуємо прокрутку сторінки при відкритті меню
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    // Очищення стилів при демонтажі компонента
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  const openMenu = () => {
    setIsOpen(true);
  };
  const closeMenu = () => {
    setIsOpen(false);
  };

  const handleClick = event => {
    const path = window.location.pathname;
    const href = event.target.getAttribute('href');
    if (path === '/en/') {
      event.preventDefault();
    }

    const index = href.indexOf('#');
    const id = href.slice(index + 1);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const blogMenuItems = [
    {
      label: (
        <NavLink to="/en/blog" onClick={closeMenu}>
          Blog (EN)
        </NavLink>
      ),
      key: 'en',
    },
    {
      label: (
        <NavLink to="/de/blog" onClick={closeMenu}>
          Blog (DE)
        </NavLink>
      ),
      key: 'de',
    },
    {
      label: (
        <NavLink to="/it/blog" onClick={closeMenu}>
          Blog (IT)
        </NavLink>
      ),
      key: 'it',
    },
  ];

  return (
    <header className={styles.header}>
      <nav className={styles.navbar}>
        {/* Бургер для відкриття меню */}
        <div className={styles.burger} onClick={isOpen ? closeMenu : openMenu}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>

        {/* Навігаційне меню */}
        <ul className={`${styles.navLinks} ${isOpen ? styles.active : ''}`}>
          <li>
            <NavLink to="/en/#home" onClick={handleClick}>
              {activeTranslate.header.homeLink}
            </NavLink>
          </li>
          <li>
            <NavLink to="/en/#about" onClick={handleClick}>
              {activeTranslate.header.aboutUsLink}
            </NavLink>
          </li>
          <li>
            <NavLink to="/en/#services" onClick={handleClick}>
              {activeTranslate.header.servicesLink}
            </NavLink>
          </li>
          <li>
            <NavLink to="/en/#projects" onClick={handleClick}>
              {activeTranslate.header.ourProjectsLink}
            </NavLink>
          </li>
          <li>
            <NavLink to="/en/#contact" onClick={handleClick}>
              {activeTranslate.header.contact}
            </NavLink>
          </li>
          <li>
            <Dropdown menu={{ items: blogMenuItems }} trigger={['click']}>
              <a onClick={e => e.preventDefault()}>
                <Space>
                  Blog
                  <DownOutlined />
                </Space>
              </a>
            </Dropdown>
          </li>

          {/* Мови */}
          {/* <li className={styles.language}>
            <a href="#en" className={lang === 'en' ? styles.activeLang : ''}>
              EN
            </a>
            |
            <a href="#de" className={lang === 'de' ? styles.activeLang : ''}>
              DE
            </a>
            |
            <a href="#it" className={lang === 'it' ? styles.activeLang : ''}>
              IT
            </a>
            |
            <a href="#es" className={lang === 'es' ? styles.activeLang : ''}>
              ES
            </a>
            |
            <a href="#pl" className={lang === 'pl' ? styles.activeLang : ''}>
              PL
            </a>
            |
            <a href="#ua" className={lang === 'ua' ? styles.activeLang : ''}>
              UA
            </a>
          </li> */}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
